export const Dark = 'dark';
export const Light = 'light';



// WEBPACK FOOTER //
// src/constants/theme.js